import React, { useState } from "react";
import Tick from '../assets/images/circle-tick.svg';
import Modal from "../Components/Modal/Modal";
import Logo from '../assets/images/logo.png'
import { Link } from "react-router-dom";
function Price() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
        <section className="my-8 md:my-16 md:px-10 2xl:px-20 overflow-hidden 2xl:py-10 h-full">
          <div className="max-w-screen-2xl text-white mx-auto px-6">
            <div className='fancy-heading [&_h2]:text-[24px] md:[&_h2]:text-[36px] 2xl:[&_h2]:text-[45px] text-white [&_h2]:font-PxBold text-center mb-8 md:mb-10 flex flex-col items-center'>
              <h2 className='flex items-center gap-x-3 before:relative before:w-12 md:before:w-32 before:h-0.5 before:bg-gradient-to-l before:from-[#28CDFA] before:via-[#29292A8C] before:to-[#29292A66] after:content-[""] after:w-12 md:after:w-32 after:h-0.5 after:bg-gradient-to-l after:from-[#29292A66] after:via-[#29292A8C] after:to-[#28CDFA]'>AI Kinnect Fixed Price</h2>
            </div>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8">
              <div className="bg-[#29292A] rounded-2xl p-6 md:p-8 relative flex flex-col">
                <div className='flex items-center justify-between'>
                  <h2 className="font-PoppinsM text-2xl">Ai kinnect fixed price tier 1  (online)-</h2>
                </div>
                <ul className="mt-6 flex flex-col gap-3 flex-1">
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> 0-50 calls per day. Maximum of 350 calls per week</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> 0.038 per call</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £1.90 per hour (average 8 hour daily open window for takeaways and restaurants).</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £15.3 per week</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £107.50 per week</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £429.99 per month</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £5,159 per year</li>
                </ul>
                <button className="mt-6 md:mt-14 -mx-3 bg-gradient-to-t from-[#2590F3] via-[#26BBF8] to-[#2CF6FE] text-white text-lg font-PoppinsL py-3 rounded-full" onClick={() => setIsModalOpen(true)}>
                  Subscribe Now
                </button>
              </div>
              <div className="bg-[#29292A] rounded-2xl p-6 md:p-8 relative flex flex-col">
                <div className='flex items-center justify-between'>
                  <h2 className="font-PoppinsM text-2xl">Ai kinnect fixed price tier 2 (online)</h2>
                </div>
                <ul className="mt-6 flex flex-col gap-3 flex-1">
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> 50-100 calls per day. Maximum of 700 calls per week.</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> 0.038 per call
                  £1.90 per hour (average 8 hour daily open window for takeaways and restaurants).</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £15.3 per week</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £107.50 per week</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £429.99 per month</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> £5,159 per year</li>
                </ul>
                <button className="mt-6 md:mt-14 -mx-3 bg-gradient-to-t from-[#2590F3] via-[#26BBF8] to-[#2CF6FE] text-white text-lg font-PoppinsL py-3 rounded-full" onClick={() => setIsModalOpen(true)}>
                  Subscribe Now
                </button>
              </div>
              <div className="bg-[#29292A] rounded-2xl p-6 md:p-8 relative flex flex-col">
                <div className='flex items-center justify-between'>
                  <h2 className="font-PoppinsM text-2xl">Ai kinnect fixed price tier 3 (online)</h2>
                </div>
                <ul className="mt-6 flex flex-col gap-3 flex-1">
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> 100-200 calls per day. Maximum of Maximum of 1,600 calls per week.</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per hour (based of average 8 hour open window)- £2</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per day- £16</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per week- £112.40</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per month- £449.99</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per year- 5,399</li>
                </ul>
                <button className="mt-6 md:mt-14 -mx-3 bg-gradient-to-t from-[#2590F3] via-[#26BBF8] to-[#2CF6FE] text-white text-lg font-PoppinsL py-3 rounded-full" onClick={() => setIsModalOpen(true)}>
                  Subscribe Now
                </button>
              </div>
              <div className="bg-[#29292A] rounded-2xl p-6 md:p-8 relative flex flex-col">
                <div className='flex items-center justify-between'>
                  <h2 className="font-PoppinsM text-2xl">Ai kinnect fixed price tier 4 (online)-</h2>
                </div>
                <ul className="mt-6 flex flex-col gap-3 flex-1">
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> 200-350 calls per day. Maximum of 2,450 calls per week.</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per hour based of average 8 hour open window- £2.13 per hour.</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per day- £17.10</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per week-£119.99</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per month- £479.99</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per year- £ 5,579</li>
                </ul>
                <button className="mt-6 md:mt-14 -mx-3 bg-gradient-to-t from-[#2590F3] via-[#26BBF8] to-[#2CF6FE] text-white text-lg font-PoppinsL py-3 rounded-full" onClick={() => setIsModalOpen(true)}>
                  Subscribe Now
                </button>
              </div>
              <div className="bg-[#29292A] rounded-2xl p-6 md:p-8 relative flex flex-col">
                <div className='flex items-center justify-between'>
                  <h2 className="font-PoppinsM text-2xl">Ai kinnect fixed price tier 5 (online)-</h2>
                </div>
                <ul className="mt-6 flex flex-col gap-3 flex-1">
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> 350+ calls per day. Maximum of 2,450 per week.</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per hour based of average 8 hour open window- £2.13 per hour.</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per day- £17.10</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per week-£119.99</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per month- £479.99</li>
                  <li className="flex gap-2.5"><span><img src={Tick} className="min-w-5 mt-0.5"/></span> Per year- £ 5,579</li>
                </ul>
                <button className="mt-6 md:mt-14 -mx-3 bg-gradient-to-t from-[#2590F3] via-[#26BBF8] to-[#2CF6FE] text-white text-lg font-PoppinsL py-3 rounded-full" onClick={() => setIsModalOpen(true)}>
                  Subscribe Now
                </button>
              </div>
            </div>
          </div>
        </section>
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="py-8">
            <div className='border-b border-[#71777D] flex justify-center pt-1 pb-6'>
              <img src={Logo}/>
            </div>
            <form className="px-8 text-white [&_.form-control]:h-12 [&_.form-control]:text-black [&_.form-control]:outline-none [&_.form-control]:rounded-full [&_.form-control]:px-5 [&_.form-control]:mt-1 flex flex-col gap-y-5 pt-10 font-PxThin">
              <div className="form-group flex flex-col">
                <label>Email</label>
                <input type="email" name="" placeholder="" className="form-control"/>
              </div>
              <div className="form-group flex flex-col">
                <label>Password</label>
                <input type="password" name="" placeholder="" className="form-control"/>
              </div>
              <div>
                <Link to="" className="text-white">Forgot Password?</Link>
              </div>
              <button className="w-full bg-gradient-to-t from-[#2590F3] via-[#26BBF8] via-46% to-[#2CF6FE] h-14 rounded-full mt-3">Log In</button>
            </form>
          </div>
        </Modal>
    </>
  )
}

export default Price;